export const areaRoutes = {
	areaAdd: '/areas/add',
	areaIndex: '/areas',
	areaHistory: (id?: string) => `/areas/${id ?? ':id'}/history`,
	areaEdit: (id?: string) => `/areas/${id ?? ':id'}`
} as const
